<template>
  <v-container class="trad-player pa-0" :class="details ? 'py-4' : 'pa-0'">
    <v-card class="pb-6" :elevation="details ? '4' : '0'" >
      <v-card-title>
        <v-row>
          <v-col cols="12" lg="12" class="d-flex align-center justify-start pa-0 setting-actions">
            <v-btn icon class="setting-handle"><v-icon>mdi-drag-vertical</v-icon></v-btn>
            <v-btn icon @click="details=!details">
              <v-icon v-if="!details">mdi-chevron-double-up</v-icon>
              <v-icon v-else>mdi-chevron-double-down</v-icon>
            </v-btn>
            <v-btn icon v-if="!onlyread"><v-icon  color="error" @click="$emit('delete-me')">mdi-delete</v-icon></v-btn>
            <v-btn icon @click="gotoStart">
              <v-icon color="info">mdi-rewind</v-icon>
            </v-btn>
            <v-btn :class="{'on': isPlaying}" icon @click="togglePlay">
              <v-icon v-if="!isPlaying" color="success">mdi-play-circle</v-icon>
              <v-icon v-else color="error">mdi-stop-circle</v-icon>
            </v-btn>
            <v-btn v-if="isDirty" class="on" icon  @click="saveSetting"><v-icon  color="info">mdi-content-save</v-icon></v-btn>
            <!-- {{  tune.recordings }} -->
              <!-- <v-checkbox class="mt-0 pt-0" dense hide-details :label="tune.title" v-model="details"></v-checkbox> -->
              <small class="overline tweak-time pl-2 grey--text"> {{ recording.title }} ({{ duration }})</smalL>
            </v-col>
        </v-row>
      </v-card-title>
      <v-card-text :class="{'pa-0': !details}">
        <trad-editor
          ref="player"
          :ctx="ctx"
          @end="$emit('end')"
          @play-status="setPlayStatus"
          @dirty-status="setDirtyStatus"
          :inner-height="details ? 256 : 32"
          :onlysurf="!details"
          :debug="debug"
          :onlyread="onlyread"
          :recording="recording"
          :setting="setting"
          ></trad-editor>
          <v-checkbox class="d-none debug-btn" dense hide-details label="debug" v-model="debug"></v-checkbox>
      </v-card-text>
    </v-card>
  </v-container>
</template>

<script>
import TradEditor from "./TradEditor.vue";

import moment from 'moment';
function pad(it) {
  let str = it.toString()
  if (str.length == 1)
    return "0" + str
  return str
}


export default {

  name: 'TradPlayer',
  components: {
    TradEditor
  },
  data: function () {
    return {
      details: false,
      isPlaying: false,
      debug: false,
      isDirty: false,
    }
  },
  methods: {
    showDetails() {
      this.details = true;
    },
    setPlayStatus(status) {
      this.isPlaying = status;
    },
    setDirtyStatus(status) {
      this.isDirty = status;
    },
    buildSurfer() {
      this.player.buildSurfer();
    },
    togglePlay() {
      this.player.togglePlay();
    },
    gotoStart() {
      this.player.gotoStart();
    },
    saveSetting() {
      this.player.saveSetting();
    },
    getCurrentTime() {
      return this.$refs.player.getCurrentTime()
    }
  },
  props: {
    setting: { type: Object },
    recording: { type: Object },
    ctx: { type: Object },
    onlyread: { type: Boolean, default: false },
  },
  computed: {
    player() { return this.$refs['player'] },
    // tune() {
    //   return this.setting.tune
    // },  
    innerHeight() {
      if (this.details) {
        return 256;
      }
      else
        return 32;
    },
    setDuration() {
      let ps = this.setting.player_settings
      if (ps.end)
        return ps.end - ps.start
      return 0
    },
    duration() {
      let d = moment.duration(this.setDuration, 'seconds')
      return "" + pad(d.minutes()) + ":" + pad(d.seconds());
    },
  },
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss">
.trad-player {
  transition: all 0.2s ease-in-out;
  .setting-actions .v-btn:not(.on){
    opacity: 0.5;
    transition: all 0.5s ease;
    &:hover {
      opacity: 1;
    }
  }
  .v-card {
  }
  .title .v-label {
    font-size: 1.2rem;
  }
}
</style>
